/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeIncidentPriorityHeadersIdempotencyKeyMin = 16;
export const changeIncidentPriorityHeadersIdempotencyKeyMax = 128;

export const changeIncidentPriorityHeadersIdempotencyKeyRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const ChangeIncidentPriorityHeaders = zod.object({
  'Idempotency-Key': zod
    .string()
    .min(changeIncidentPriorityHeadersIdempotencyKeyMin)
    .max(changeIncidentPriorityHeadersIdempotencyKeyMax)
    .regex(changeIncidentPriorityHeadersIdempotencyKeyRegExp),
  'x-csrf-token': zod.string(),
});

export type ChangeIncidentPriorityHeaders = zod.input<typeof ChangeIncidentPriorityHeaders>;
export type ChangeIncidentPriorityHeadersOutput = zod.output<typeof ChangeIncidentPriorityHeaders>;
